import { isDefinedArray } from "et3-type-guards";
import getUserConversationStore from "../../../../stores/user-store/conversation-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Div from "../../../../core/et3-div";

const LoadMoreButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const converationData = getUserConversationStore().conversationData.get();
  const { conversation } = converationData;
  const shouldShow = isDefinedArray(conversation) && conversation.length > 499;

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={45}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={true}
        onClick={async () =>
          await getUserConversationStore().getConversation({
            isLoadMore: true
          })
        }
        size="MEDIUM"
        text="LOAD_MORE"
        type="GET"
      />
    </ET3Div>
  ) : null;
});
export default LoadMoreButton;
